<template>
    <div v-loading="!loading">
        <hts-analytics-card-chart
            v-if="loading"
            :title="getLabel()"
            fill-color="#e11d48"
            height="220"
            :labels="labels"
            :series="[{ name: 'Tổng', data: series }]" />
        <div
            v-else
            class="h-[220px]" />
    </div>
</template>

<script lang="ts" setup>
import statistic from '~/composables/api-url/statistic'
import { $lodash } from '#imports'

const props = defineProps({
  module: {
    type: String,
    required: true
  }
})
const { module } = toRefs(props)
const dataReport = ref<{ [key: string]: any }>({})

const loading = ref(true)
const getStatistic = async () => {
  loading.value = false
  const api = $url.statistic.getStatistic
  const res = await $api(api, {
    uriParams: {
      CLASS: module.value
    },
    params: {
      typeReport: 'statistical'
    }
  })
  const resData: any = res?.data.value
  if (resData?.success) {
    dataReport.value = resData.data
    editDataReportChart()
  }
  loading.value = true
  return null
}
const labels = ref<Array<string>>([])
const series = ref<Array<number>>([])
const editDataReportChart = () => {
  series.value = $lodash.map(dataReport.value?.statistical, 'count')
  labels.value = $lodash.map(dataReport.value?.statistical, 'text')
}

onBeforeMount(async () => {
  await getStatistic()
})

const getLabel = () => {
  switch (module.value) {
  case 'vehicles':
    return 'Số lượng xe được tạo hàng tháng'
  case 'driver':
    return 'Số lượng tài xế được tạo hàng tháng'
  case 'order':
    return 'Số lượng đơn hàng được tạo hàng tháng'
  case 'quote':
    return 'Số lượng báo giá được tạo hàng tháng'
  case 'quoteRequest':
    return 'Số lượng yêu cầu báo giá được tạo hàng tháng'
  default:
    return 'Unknow'
  }
}
</script>

<style scoped></style>
